import standardEvents from './eventDictionaryStandard';
import eventPayload from './eventPayload';
import storeEvent from './storeEvent';

const CONSOLE_LOG_EVENT_NAME = false;
const CONSOLE_LOG_EVENT_PROPS = false;

/* eslint-disable no-console */

export default function(eventName, options, cb) {
  const amplitudeEventName = standardEvents[eventName];
  const payload = eventPayload(options);

  if (!window.amplitude) {
    console.log('Amplitude not loaded');

    return;
  }

  storeEvent(amplitudeEventName, payload, cb);
  printEvent(amplitudeEventName, payload);
}

const printEvent = (amplitudeEventName, payload) => {
  if (CONSOLE_LOG_EVENT_NAME)  {
    console.log('EVT --> ', amplitudeEventName);
  }

  if (CONSOLE_LOG_EVENT_PROPS) {
    for (const key in payload) {
      console.log(`prop --> ${key} => ${String(payload[key]).substr(0, 50)}`);
    }
    console.log(' ');
    console.log(' ');
    console.log(' ');
  }
};
